import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 32,
	viewBox: "0 0 36 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M33.188 18.265h-3.044v-2.97c0-1.633-1.336-2.97-3.044-2.97h-10.023l-4.009-3.935h-10.023c-1.708 0-3.044 1.336-3.044 2.97v17.671c0 1.633 1.336 2.97 3.044 2.97h25.169c1.039 0 2.005-0.52 2.524-1.411l5.049-7.87c1.262-1.93-0.223-4.455-2.599-4.455zM3.044 11.731c0-0.223 0.148-0.371 0.371-0.371h8.464l4.009 3.935h10.914c0.223 0 0.371 0.149 0.371 0.371v2.599h-17.596c-1.039 0-2.005 0.52-2.599 1.411l-3.935 6.385c0 0 0-14.329 0-14.329zM28.213 29.104h-23.684l4.9-7.87h23.833l-5.049 7.87zM31.629 10.394v-4.306h2.821c0.594 0 0.891-0.668 0.445-1.114l-4.9-4.826c-0.223-0.223-0.668-0.223-0.891 0l-4.9 4.826c-0.371 0.371-0.148 1.114 0.445 1.114h2.821v4.306c0 0.445 0.371 0.742 0.817 0.742h2.599c0.371 0 0.742-0.371 0.742-0.742z" })
});
export default SvgFileUpload;
